export var ModelBackendEnum;
(function (ModelBackendEnum) {
    ModelBackendEnum["LUXONIS"] = "LUXONIS";
    ModelBackendEnum["ULTRALYTICS"] = "ULTRALYTICS";
    ModelBackendEnum["RF_DETR"] = "RF_DETR";
    ModelBackendEnum["ULTRA_VISION"] = "ULTRA_VISION";
})(ModelBackendEnum || (ModelBackendEnum = {}));
//# sourceMappingURL=model.enums.js.map